import { getRedirectForStep } from './get-redirect-for-step';

export function getResumeRoute(completedStep: number): string {
  return getRedirectForStep(completedStep);
}

